import { useState } from "react";
import { useAuthContext } from "./useAuthContext";
import Api from "../api/Api";
import { Urls } from "../api/Urls";

export const useLogin = (email, otp) => {
  const [errorLogin, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(null);

  const { dispatch } = useAuthContext();

  const login = async (email, password) => {
    setIsLoading(true);
    setError(null);

    //remove const response = await
    const response = await Api.post(
      Urls.AUTH_ADMIN,
      { email: email, password: password },
      {
        headers: { "Content-type": "application/json" },
      }
    )
      .then((response) => {
        // console.log(response);

        if (response.status === 200) {
          // save the user to local storage
          localStorage.setItem("user", JSON.stringify(response.data));

          // update the auth context
          dispatch({ type: "LOGIN", payload: response.data });

          // update loading state
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        setError(error.response.data.message);
        // console.log(error.response.data.message);
        // console.log(error);
      });
  };

  return { login, isLoading, errorLogin };
};
